import { Services } from '@sigma-frontend-libs/commons'

import overflow from '@/components/text/overflow'

function renderRow(h, value) {
  return h(
    overflow,
    {
      class: `${Services['report-manager']}-date-range__item`,
      props: { value }
    }
  )
}
function renderRows(h) {
  return this.rows.map(row => {
    return renderRow.call(this, h, row)
  })
}

export default function(h) {
  return h(
    'div',
    {
      class: `${Services['report-manager']}-date-range__tag`,
      directives: this.$_directives
    },
    [ renderRows.call(this, h) ]
  )
}
